export default __webpack_public_path__ + "static/media/865.555c9081.png";